import {
    ProtocolConsumptionSyncAnalysisState,
    ProtocolConsumptionSyncAnalysisUnloadState,
} from '../../states/ProtocolConsumptionSyncAnalysis.States';
import * as actions from '../../actions/ProtocolConsumptionSyncAnalysis.Actions';

export default function ProtocolConsumptionSyncAnalysisReducer(
    state: ProtocolConsumptionSyncAnalysisState | undefined,
    action: any
): ProtocolConsumptionSyncAnalysisState {
    const currentState = state ?? ProtocolConsumptionSyncAnalysisUnloadState;

    switch (action.type) {
        case actions.SYNCANALYSIS_GET_REQUEST:
            return {
                ...currentState,
                isGettingAnalysis: true,
                successGettingAnalysis: undefined,
                failOnGettingAnalysis: false,
                error: undefined,
            };
        case actions.SYNCANALYSIS_GET_SUCCESS:
            return {
                ...currentState,
                isGettingAnalysis: false,
                successGettingAnalysis: true,
                failOnGettingAnalysis: false,
                analysisBySyncProcessId: {
                    ...currentState.analysisBySyncProcessId,
                    // null es un valor con significado —la corrida no fue
                    // analizada— y se guarda como tal para no volver a pedirlo.
                    [action.syncProcessId]: action.analysis ?? null,
                },
            };
        case actions.SYNCANALYSIS_GET_FAILURE:
            return {
                ...currentState,
                isGettingAnalysis: false,
                successGettingAnalysis: false,
                failOnGettingAnalysis: true,
                error: action.error,
            };

        case actions.SYNCANALYSIS_GETFINDINGS_REQUEST:
            return {
                ...currentState,
                isGettingFindings: true,
                successGettingFindings: undefined,
                failOnGettingFindings: false,
                error: undefined,
            };
        case actions.SYNCANALYSIS_GETFINDINGS_SUCCESS:
            return {
                ...currentState,
                isGettingFindings: false,
                successGettingFindings: true,
                failOnGettingFindings: false,
                findingsByAnalysisId: {
                    ...currentState.findingsByAnalysisId,
                    [action.analysisId]: action.findings ?? [],
                },
                findingsPaginationByAnalysisId: {
                    ...currentState.findingsPaginationByAnalysisId,
                    [action.analysisId]: action.paginationState,
                },
            };
        case actions.SYNCANALYSIS_GETFINDINGS_FAILURE:
            return {
                ...currentState,
                isGettingFindings: false,
                successGettingFindings: false,
                failOnGettingFindings: true,
                error: action.error,
            };

        default:
            return currentState;
    }
}
